export default __webpack_public_path__ + "static/media/QCMprojet.d9d96ffd.png";